import React from "react";
import { NavLink } from "react-router";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { IChannel } from "../../../services";

interface ChatThumbnailWrapperProps {
  children: React.ReactNode;
  chat: IChannel;
  isDragging: boolean;
  hasNotification?: boolean;
  handleChatClick: (e: React.MouseEvent) => void;
}

const ChatThumbnailWrapper: React.FC<ChatThumbnailWrapperProps> = ({
  children,
  chat,
  isDragging,
  hasNotification,
  handleChatClick,
}) => {
  const theme = useTheme();
  const notificationStyle = hasNotification
    ? { backgroundColor: theme.palette.alert_success.light }
    : undefined;
  const hoverClass =
    !isDragging && !hasNotification ? "hover:bg-hex-gray-100" : "";

  if (isDragging) {
    return (
      <Box
        className="group flex w-full pl-4 pr-6 py-1 flex-col items-start gap-0 rounded-lg cursor-pointer relative overflow-hidden border border-transparent"
        sx={notificationStyle}
      >
        {children}
      </Box>
    );
  }

  return (
    <NavLink
      draggable={false}
      className={({ isActive }: { isActive: boolean }) =>
        `group flex w-full pl-4 pr-6 py-[7px] flex-col items-start gap-0 rounded-lg ${hoverClass} cursor-pointer relative overflow-hidden border ${
          isActive && !hasNotification
            ? "border-hex-gray-200 bg-hex-gray-100"
            : "border-transparent"
        }`
      }
      style={notificationStyle}
      to={`/channels/${chat.name}`}
      onClick={handleChatClick}
      onDragStart={(e) => e.preventDefault()}
    >
      {children}
    </NavLink>
  );
};

export default ChatThumbnailWrapper;
